import GradStop from './gradStop/main';

const defaultColors = [
  ['#0D003F', '#8547C5', '#E0B0E8'],
  ['#002541', '#00C4C1', '#A6E6CD'],
  ['#00153D', '#00D8FF', '#95EFFF'],
  ['#340034', '#F65CD2', '#F6D1DC'],
];

const generateComparisionColors = ({ number, index }, colors = defaultColors) => {
  if (number < 2) {
    return [colors[index][1]];
  }
  if (number === 2) {
    return [colors[index][1], colors[index][2]];
  }
  if (number === 3) {
    return GradStop({
      inputFormat: 'hex',
      stops: 4,
      colorArray: colors[index],
    }).slice(1, 4);
  }

  return GradStop({
    inputFormat: 'hex',
    stops: number,
    colorArray: colors[index],
  });
};

export default generateComparisionColors;
